import * as React from "react";
import type { SVGProps } from "react";
const SvgUpload03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20.4 8.78V5.074c0-.561-.221-1.1-.615-1.497a2.1 2.1 0 0 0-1.485-.62H5.7c-.557 0-1.091.223-1.485.62A2.13 2.13 0 0 0 3.6 5.074V8.78m8.399 12.263v-12m0 0-4.8 4.586m4.8-4.586 4.8 4.586"
    />
  </svg>
);
export default SvgUpload03;
